import React from 'react';
import { Greyscale, PrimaryColor } from 'glints-aries';
import {
  Badge,
  Button,
  ButtonProps,
  Icon,
  PrimaryButton,
  Typography,
} from 'glints-aries/es/@next';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import clampedNum from '../../common/clamped';

type ButtonVariant = 'default' | 'primary';

type ChatButtonProps = ButtonProps & {
  variant?: ButtonVariant;
  unreadCount?: number;
  content?: React.ReactNode;
};

const btnVariantMap = {
  default: Button,
  primary: PrimaryButton,
};

const StyledBadge = styled(Badge)`
  background-color: ${PrimaryColor.glintsred};
  border: 2px solid ${Greyscale.white};
  position: absolute;
  top: -12px;
  right: -12px;
  padding: 2px 6px 2px 8px;
  text-align: center;
  transform-origin: top right;
  z-index: 2;
`;

const ChatButton = ({
  variant = 'default',
  unreadCount,
  style,
  content,
  ...rest
}: ChatButtonProps) => {
  const ButtonComponent = btnVariantMap[variant];
  const clampedUnreadCount = clampedNum({
    count: unreadCount,
    max: 99,
  });

  return (
    <ButtonComponent
      icon={<Icon name="ri-message-line" />}
      {...rest}
      style={{ ...style, position: 'relative', overflow: 'visible' }}
    >
      <Typography variant="button">
        {content ?? (
          <FormattedMessage id="button-text_chat" defaultMessage="Chat" />
        )}
      </Typography>
      <If condition={clampedUnreadCount}>
        <StyledBadge>
          <Typography variant="overline" color={Greyscale.white}>
            {clampedUnreadCount}
          </Typography>
        </StyledBadge>
      </If>
    </ButtonComponent>
  );
};
export default ChatButton;
